export default "__VITE_ASSET__CKW5ld6T__"